import {ContactType} from "@/components/communications/models/contactModel";

export enum CommunicationType {
  SMS = 1,
  EMAIL
}

export interface UiMessage {
  id: string;
  isRead: boolean;
  isStarred: boolean;
  isChecked: boolean;
  targetFirstName: string;
  targetLastName: string;
  lastActiveTime: string;
  latestCampaign: string;
  messagePreview: string;
  isExpanded: boolean;
  providerId: number;
  facilityContactId: number;
  deliveryStatus: string;
  providerTitle?: string;
}

export interface ConversationSummary {
  id: string;
  messageContent: string;
  isRead: boolean;
  occurredOn: string;
  contactFirstName: string;
  contactLastName: string;
  campaignTitle: string;
  providerId: number;
  facilityContactId: number;
  deliveryStatus: string;
  providerTitle?: string;
}

export interface CampaignItem {
  campaignId: string;
  providerId: number;
  facilityContactId: number;
  subject?: string;
  messageContent: string;
  campaignTitle: string;
  teamMember: string;
  createdOn: Date;
  recipientIds: number[];
}

export enum MessageContainer {
  Purple = 1,
  Blue,
  Red,
  Green
}

export interface OptOutPayload {
  messageIds: string[];
  communicationTypeId: CommunicationType;
  receiverTypeId: ContactType;

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/communications/CommunicationInterfaces.ts